import React from 'react';
import './accounts.scss';
import Button from '../../common/Button/Button';
import { Link } from 'react-router-dom';
import Modal from '../Modal/Modal';
import Input from '../Input/Input';
import { putProfileDetails } from 'hb-redux-store/feature/accounts/accounts.action';
import { isLoggedInUser as isLoggedIn } from '../../../hb-redux-store/util/cookieService';
import { connect } from 'react-redux';
import { setAppNotification } from '../../../hb-redux-store/initial.action';
import {
  EMAIL_REGEX,
  NAME_REGEX,
} from '../../../hb-redux-store/util/constantServices';

class AccountsMainNav extends React.Component {
  state = {
    showUpdateModal: false,
    fullName: '',
    accountEmail: '',
    mobile: '',
    emailError: false,
  };
  componentDidUpdate(prevProps, prevState, snapshot) {
    const thisProps = this.props;
    if (thisProps.launchInfo?.mobile && !this.state.mobile) {
      this.setState({
        fullName: thisProps.launchInfo.customerFullName || '',
        mobile: thisProps.launchInfo.mobile,
        accountEmail: thisProps.launchInfo.email || '',
      });
    }
  }

  onCancel = () => {
    this.setState({ showUpdateModal: false });
  };

  updateDetails = () => {
    const { fullName: customerFullName, accountEmail } = this.state;
    if (this.invalidEmail(accountEmail)) return;
    if (this.invalidName(customerFullName)) return;
    const successCb = () => {
      this.setState({ showUpdateModal: false });
      this.props.setAppNotification('Profile details updated.');
    };
    const failureCb = () => {
      this.setState({ showUpdateModal: false });
      this.props.setAppNotification('Error updating profile details.');
    };
    const updateData = {
      customerFullName,
      accountEmail,
      successCb,
      failureCb,
    };
    this.setState({ nameError: false, emailError: false }, () => {
      this.props.putProfileDetails(updateData);
    });
  };
  isLoggedInUser = isLoggedIn();
  invalidEmail = accountEmail => {
    let invalidEmail = false;
    if (accountEmail?.length) {
      invalidEmail = !EMAIL_REGEX.test(accountEmail);
    } else {
      invalidEmail = true;
    }
    this.setState({ emailError: invalidEmail });
    return invalidEmail;
  };

  invalidName = fullName => {
    let invalidName = false;
    if (fullName?.length) {
      invalidName = !NAME_REGEX.test(fullName);
    } else {
      invalidName = true;
    }
    this.setState({ nameError: invalidName });
    return invalidName;
  };

  render() {
    const { customerFullName: name, mobile, email } =
      this.props.launchInfo || {};
    const { isLoggedInUser } = this;
    return (
      <div className={`accounts-nav ${!isLoggedInUser ? 'visitor' : ''}`}>
        {!isLoggedInUser && (
          <React.Fragment>
            <div className="accounts-nav--user">
              <div className="user-name">
                Hello, <br />
                Login to get started.
              </div>
            </div>
            <div className="accounts-nav--edit-cta">
              <Link className="button nav--cta" to="/login">
                Login
              </Link>
            </div>
          </React.Fragment>
        )}
        {isLoggedInUser && (
          <React.Fragment>
            <div className="accounts-nav--user">
              {name && <div className="user-name">{name}</div>}
              {!name && (
                <div
                  className="user-name"
                  onClick={() => this.setState({ showUpdateModal: true })}
                >
                  Enter name
                </div>
              )}
              <div className="user-contact">
                {mobile && <span className="phone-no">{mobile}</span>}
                {!mobile && <span className="phone-no">Enter mobile no</span>}
                <span className="contact-divider"></span>
                {email && <span className="email">{email}</span>}
                {!email && (
                  <span
                    className="email"
                    onClick={() => this.setState({ showUpdateModal: true })}
                  >
                    Enter email
                  </span>
                )}
              </div>
            </div>
            <div className="accounts-nav--edit-cta">
              <Button
                className="button nav--cta"
                onClick={() => this.setState({ showUpdateModal: true })}
              >
                Edit
              </Button>
            </div>
          </React.Fragment>
        )}
        <Modal
          visible={this.state.showUpdateModal}
          onCancel={this.onCancel}
          footer={null}
          centered={true}
          destroyOnClose={true}
          title="Update profile details"
          wrapClassName="add-new-card"
        >
          <Input
            type="text"
            className="add-new-card--card-no"
            onChange={({ fullName }) => this.setState({ fullName })}
            value={this.state.fullName}
            name="fullName"
            autoFocus
            placeholder="Name *"
            maxLength={30}
            hasError={this.state.nameError}
            errorMsg="Please enter valid name."
            onBlur={({ fullName }) => this.invalidName(fullName)}
          />
          <Input
            type="text"
            className="add-new-card--card-no"
            onChange={({ accountEmail }) => this.setState({ accountEmail })}
            value={this.state.accountEmail}
            name="accountEmail"
            placeholder="Email Id *"
            maxLength={40}
            errorMsg="Please enter valid email."
            hasError={this.state.emailError}
            onBlur={({ accountEmail }) => this.invalidEmail(accountEmail)}
          />
          <Input
            type="mobile"
            className="add-new-card--card-no"
            onChange={({ mobile }) => this.setState({ mobile })}
            value={this.state.mobile}
            name="mobile"
            placeholder="Mobile No"
            maxLength={14}
            disabled={true}
          />
          <Button
            className="button button-primary full-width large"
            onClick={this.updateDetails}
          >
            Update Details
          </Button>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = ({ initialReducer }) => ({
  launchInfo: initialReducer.launchInfo,
});

const mapDispatchToProps = {
  putProfileDetails,
  setAppNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountsMainNav);
